// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../node_modules/bootstrap/dist/css/bootstrap.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../node_modules/@formio/js/dist/formio.full.min.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --Primary-Main: #ce8f00;
  --Primary-Dark: #475467;
  --Primary-Light: #d8d8dc;
  --Primary-Gradient-Start: #f5d793;
  --Primary-Gradient-End: light-Primary-Gradient-End;
  --Primary-SemiDark: #ccc2ab;
  --Primary-SemiLight: #8c7030;
  --Secondary-Main: #3982f8;
  --Secondary-Pale: #ceebf5;
  --Secondary-Gradient-Start: #f5d793;
  --Secondary-Gradient-End: #005d7b;
  --Neutral-BG-Light: #ffffff;
  --Neutral-BG-Dark: #e0dbce;
  --Neutral-BG-Shadow: #000000;
  --Neutral-BG-Main: #f5f5f5;
  --Neutral-BG-Shadow2: #1b1b1b;
  --Neutral-BG-Backdrop: #333333;
  --Neutral-Text-Title: #290905;
  --Neutral-Text-Caption: #827d7c;
  --Neutral-Text-CaptionT2: #6b6862;
  --Neutral-Text-Title2: #291d05;
  --Neutral-Text-Title3: #ffffff;
  --Semantic-Success-Main: #42b778;
  --Semantic-Success-Light: #96fda0;
  --Semantic-Success-Pale: #ecfdf3;
  --Semantic-Error: #e05151;
  --Semantic-Progress-Main: #344054;
  --Semantic-Progress-Pale: #f2f4f7;
  --Warning-Progress-Main: #ce8f00;
  --Warning-Progress-Pale: #fffaeb;
  --ColorPallet-Red: #eb5757;
  --ColorPallet-Green: #27ae60;
  --ColorPallet-Blue: #2d9cdb;
  --ColorPallet-Yellow: #f2c94c;
  --ColorPallet-Orange: #f2994a;
  --ColorPallet-BabyBlue: #d3ebff;
  --ColorPallet-Pink: #db2daa;
  --ColorPallet-Irancell: #ffcb05;
  --ColorPallet-Irancell2: #291d05;
  --ColorPallet-PaleRed: #eed4d3;
  --ColorPallet-Purple: #ad64cb;
  --Others-Gray: #fcfcfd;
  --Others-Gray2: #eaecf0;
  --dark-Primary-Main: #fcce65;
  --dark-Primary-Dark: #b88b25;
  --dark-Primary-Light: #403f3c;
  --dark-Primary-Gradient-Start: #f3dfb2;
  --dark-Primary-Gradient-End: dark-Primary-Gradient-End;
  --dark-Primary-SemiDark: #ccc2ab;
  --dark-Primary-SemiLight: #8c7030;
  --dark-Secondary-Main: #3295b6;
  --dark-Secondary-Pale: #ceebf5;
  --dark-Secondary-Gradient-Start: #1bafdf;
  --dark-Secondary-Gradient-End: #005d7b;
  --dark-Neutral-BG-Light: #333333;
  --dark-Neutral-BG-Dark: #262626;
  --dark-Neutral-BG-Shadow: #e4e2e2;
  --dark-Neutral-BG-Main: #1e1e1e;
  --dark-Neutral-BG-Shadow2: #282828;
  --dark-Neutral-BG-Backdrop: #0a0a0a;
  --dark-Neutral-Text-Title: #f7f7f5;
  --dark-Neutral-Text-Caption: #c0c0c0;
  --dark-Neutral-Text-CaptionT2: #d7d7d7;
  --dark-Neutral-Text-Title2: #080a0a;
  --dark-Neutral-Text-Title3: #ffffff;
  --dark-Semantic-Success-Main: #66b78c;
  --dark-Semantic-Success-Light: #c8fdcd;
  --dark-Semantic-Success-Pale: #ecfdf3;
  --dark-Semantic-Error: #e07e7e;
  --dark-Semantic-Progress-Main: #344054;
  --dark-Semantic-Progress-Pale: #f2f4f7;
  --dark-Warning-Progress-Main: #ce8f00;
  --dark-Warning-Progress-Pale: #fffaeb;
  --dark-ColorPallet-Red: #fc8d8d;
  --dark-ColorPallet-Green: #49ae74;
  --dark-ColorPallet-Blue: #5aacdb;
  --dark-ColorPallet-Yellow: #f2d57b;
  --dark-ColorPallet-Orange: #f2b37b;
  --dark-ColorPallet-BabyBlue: #d3ebff;
  --dark-ColorPallet-Pink: #db5ab7;
  --dark-ColorPallet-Irancell: #ffcb05;
  --dark-ColorPallet-Irancell2: #ffcb05;
  --dark-ColorPallet-PaleRed: #eed4d3;
  --dark-ColorPallet-Purple: #b98ccb;
  --dark-Others-Gray: #fcfcfd;
  --dark-Others-Gray2: #eaecf0;
}

.m-0 {
  margin: 0px;
}

.ml-0 {
  margin-inline-start: 0px;
}

.mr-0 {
  margin-inline-end: 0px;
}

.mt-0 {
  margin-top: 0px;
}

.mb-0 {
  margin-bottom: 0px;
}

.mx-0 {
  margin-inline: 0px;
}

.my-0 {
  margin-block: 0px;
}

.m-1 {
  margin: 10px;
}

.ml-1 {
  margin-inline-start: 10px;
}

.mr-1 {
  margin-inline-end: 10px;
}

.mt-1 {
  margin-top: 10px;
}

.mb-1 {
  margin-bottom: 10px;
}

.mx-1 {
  margin-inline: 10px;
}

.my-1 {
  margin-block: 10px;
}

.m-2 {
  margin: 20px;
}

.ml-2 {
  margin-inline-start: 20px;
}

.mr-2 {
  margin-inline-end: 20px;
}

.mt-2 {
  margin-top: 20px;
}

.mb-2 {
  margin-bottom: 20px;
}

.mx-2 {
  margin-inline: 20px;
}

.my-2 {
  margin-block: 20px;
}

.m-3 {
  margin: 30px;
}

.ml-3 {
  margin-inline-start: 30px;
}

.mr-3 {
  margin-inline-end: 30px;
}

.mt-3 {
  margin-top: 30px;
}

.mb-3 {
  margin-bottom: 30px;
}

.mx-3 {
  margin-inline: 30px;
}

.my-3 {
  margin-block: 30px;
}

.m-4 {
  margin: 40px;
}

.ml-4 {
  margin-inline-start: 40px;
}

.mr-4 {
  margin-inline-end: 40px;
}

.mt-4 {
  margin-top: 40px;
}

.mb-4 {
  margin-bottom: 40px;
}

.mx-4 {
  margin-inline: 40px;
}

.my-4 {
  margin-block: 40px;
}

.m-5 {
  margin: 50px;
}

.ml-5 {
  margin-inline-start: 50px;
}

.mr-5 {
  margin-inline-end: 50px;
}

.mt-5 {
  margin-top: 50px;
}

.mb-5 {
  margin-bottom: 50px;
}

.mx-5 {
  margin-inline: 50px;
}

.my-5 {
  margin-block: 50px;
}

.m-6 {
  margin: 60px;
}

.ml-6 {
  margin-inline-start: 60px;
}

.mr-6 {
  margin-inline-end: 60px;
}

.mt-6 {
  margin-top: 60px;
}

.mb-6 {
  margin-bottom: 60px;
}

.mx-6 {
  margin-inline: 60px;
}

.my-6 {
  margin-block: 60px;
}

.m-7 {
  margin: 70px;
}

.ml-7 {
  margin-inline-start: 70px;
}

.mr-7 {
  margin-inline-end: 70px;
}

.mt-7 {
  margin-top: 70px;
}

.mb-7 {
  margin-bottom: 70px;
}

.mx-7 {
  margin-inline: 70px;
}

.my-7 {
  margin-block: 70px;
}

.m-8 {
  margin: 80px;
}

.ml-8 {
  margin-inline-start: 80px;
}

.mr-8 {
  margin-inline-end: 80px;
}

.mt-8 {
  margin-top: 80px;
}

.mb-8 {
  margin-bottom: 80px;
}

.mx-8 {
  margin-inline: 80px;
}

.my-8 {
  margin-block: 80px;
}

.m-9 {
  margin: 90px;
}

.ml-9 {
  margin-inline-start: 90px;
}

.mr-9 {
  margin-inline-end: 90px;
}

.mt-9 {
  margin-top: 90px;
}

.mb-9 {
  margin-bottom: 90px;
}

.mx-9 {
  margin-inline: 90px;
}

.my-9 {
  margin-block: 90px;
}

.m-10 {
  margin: 100px;
}

.ml-10 {
  margin-inline-start: 100px;
}

.mr-10 {
  margin-inline-end: 100px;
}

.mt-10 {
  margin-top: 100px;
}

.mb-10 {
  margin-bottom: 100px;
}

.mx-10 {
  margin-inline: 100px;
}

.my-10 {
  margin-block: 100px;
}

.m-11 {
  margin: 110px;
}

.ml-11 {
  margin-inline-start: 110px;
}

.mr-11 {
  margin-inline-end: 110px;
}

.mt-11 {
  margin-top: 110px;
}

.mb-11 {
  margin-bottom: 110px;
}

.mx-11 {
  margin-inline: 110px;
}

.my-11 {
  margin-block: 110px;
}

.m-12 {
  margin: 120px;
}

.ml-12 {
  margin-inline-start: 120px;
}

.mr-12 {
  margin-inline-end: 120px;
}

.mt-12 {
  margin-top: 120px;
}

.mb-12 {
  margin-bottom: 120px;
}

.mx-12 {
  margin-inline: 120px;
}

.my-12 {
  margin-block: 120px;
}

.ml-auto {
  margin-left: auto;
}

.mr-auto {
  margin-right: auto;
}

.mt-auto {
  margin-top: auto;
}

.mb-auto {
  margin-bottom: auto;
}

.mx-auto {
  margin-inline: auto;
}

.my-auto {
  margin-block: auto;
}

.m-auto {
  margin: auto;
}

.ml-0 {
  margin-left: 0;
}

.mr-0 {
  margin-right: 0;
}

.mt-0 {
  margin-top: 0;
}

.mb-0 {
  margin-bottom: 0;
}

.mx-0 {
  margin-inline: 0;
}

.my-0 {
  margin-block: 0;
}

.p-0 {
  padding: 0px;
}

.pl-0 {
  padding-inline-start: 0px;
}

.pr-0 {
  padding-inline-end: 0px;
}

.pt-0 {
  padding-top: 0px;
}

.pb-0 {
  padding-bottom: 0px;
}

.px-0 {
  padding-inline: 0px;
}

.py-0 {
  padding-block: 0px;
}

.p-1 {
  padding: 10px;
}

.pl-1 {
  padding-inline-start: 10px;
}

.pr-1 {
  padding-inline-end: 10px;
}

.pt-1 {
  padding-top: 10px;
}

.pb-1 {
  padding-bottom: 10px;
}

.px-1 {
  padding-inline: 10px;
}

.py-1 {
  padding-block: 10px;
}

.p-2 {
  padding: 20px;
}

.pl-2 {
  padding-inline-start: 20px;
}

.pr-2 {
  padding-inline-end: 20px;
}

.pt-2 {
  padding-top: 20px;
}

.pb-2 {
  padding-bottom: 20px;
}

.px-2 {
  padding-inline: 20px;
}

.py-2 {
  padding-block: 20px;
}

.p-3 {
  padding: 30px;
}

.pl-3 {
  padding-inline-start: 30px;
}

.pr-3 {
  padding-inline-end: 30px;
}

.pt-3 {
  padding-top: 30px;
}

.pb-3 {
  padding-bottom: 30px;
}

.px-3 {
  padding-inline: 30px;
}

.py-3 {
  padding-block: 30px;
}

.p-4 {
  padding: 40px;
}

.pl-4 {
  padding-inline-start: 40px;
}

.pr-4 {
  padding-inline-end: 40px;
}

.pt-4 {
  padding-top: 40px;
}

.pb-4 {
  padding-bottom: 40px;
}

.px-4 {
  padding-inline: 40px;
}

.py-4 {
  padding-block: 40px;
}

.p-5 {
  padding: 50px;
}

.pl-5 {
  padding-inline-start: 50px;
}

.pr-5 {
  padding-inline-end: 50px;
}

.pt-5 {
  padding-top: 50px;
}

.pb-5 {
  padding-bottom: 50px;
}

.px-5 {
  padding-inline: 50px;
}

.py-5 {
  padding-block: 50px;
}

.p-6 {
  padding: 60px;
}

.pl-6 {
  padding-inline-start: 60px;
}

.pr-6 {
  padding-inline-end: 60px;
}

.pt-6 {
  padding-top: 60px;
}

.pb-6 {
  padding-bottom: 60px;
}

.px-6 {
  padding-inline: 60px;
}

.py-6 {
  padding-block: 60px;
}

.p-7 {
  padding: 70px;
}

.pl-7 {
  padding-inline-start: 70px;
}

.pr-7 {
  padding-inline-end: 70px;
}

.pt-7 {
  padding-top: 70px;
}

.pb-7 {
  padding-bottom: 70px;
}

.px-7 {
  padding-inline: 70px;
}

.py-7 {
  padding-block: 70px;
}

.p-8 {
  padding: 80px;
}

.pl-8 {
  padding-inline-start: 80px;
}

.pr-8 {
  padding-inline-end: 80px;
}

.pt-8 {
  padding-top: 80px;
}

.pb-8 {
  padding-bottom: 80px;
}

.px-8 {
  padding-inline: 80px;
}

.py-8 {
  padding-block: 80px;
}

.p-9 {
  padding: 90px;
}

.pl-9 {
  padding-inline-start: 90px;
}

.pr-9 {
  padding-inline-end: 90px;
}

.pt-9 {
  padding-top: 90px;
}

.pb-9 {
  padding-bottom: 90px;
}

.px-9 {
  padding-inline: 90px;
}

.py-9 {
  padding-block: 90px;
}

.p-10 {
  padding: 100px;
}

.pl-10 {
  padding-inline-start: 100px;
}

.pr-10 {
  padding-inline-end: 100px;
}

.pt-10 {
  padding-top: 100px;
}

.pb-10 {
  padding-bottom: 100px;
}

.px-10 {
  padding-inline: 100px;
}

.py-10 {
  padding-block: 100px;
}

.p-11 {
  padding: 110px;
}

.pl-11 {
  padding-inline-start: 110px;
}

.pr-11 {
  padding-inline-end: 110px;
}

.pt-11 {
  padding-top: 110px;
}

.pb-11 {
  padding-bottom: 110px;
}

.px-11 {
  padding-inline: 110px;
}

.py-11 {
  padding-block: 110px;
}

.p-12 {
  padding: 120px;
}

.pl-12 {
  padding-inline-start: 120px;
}

.pr-12 {
  padding-inline-end: 120px;
}

.pt-12 {
  padding-top: 120px;
}

.pb-12 {
  padding-bottom: 120px;
}

.px-12 {
  padding-inline: 120px;
}

.py-12 {
  padding-block: 120px;
}

.pl-auto {
  padding-left: auto;
}

.pr-auto {
  padding-right: auto;
}

.pt-auto {
  padding-top: auto;
}

.pb-auto {
  padding-bottom: auto;
}

.px-auto {
  padding-inline: auto;
}

.py-auto {
  padding-block: auto;
}

.p-auto {
  padding: auto;
}

.pl-0 {
  padding-left: 0;
}

.pr-0 {
  padding-right: 0;
}

.pt-0 {
  padding-top: 0;
}

.pb-0 {
  padding-bottom: 0;
}

.px-0 {
  padding-inline: 0;
}

.py-0 {
  padding-block: 0;
}

.gap-0 {
  gap: 0px;
}

.gap-1 {
  gap: 10px;
}

.gap-2 {
  gap: 20px;
}

.gap-3 {
  gap: 30px;
}

.gap-4 {
  gap: 40px;
}

.gap-5 {
  gap: 50px;
}

.gap-6 {
  gap: 60px;
}

.gap-7 {
  gap: 70px;
}

.gap-8 {
  gap: 80px;
}

.gap-9 {
  gap: 90px;
}

.gap-10 {
  gap: 100px;
}

.gap-11 {
  gap: 110px;
}

.gap-12 {
  gap: 120px;
}

.gap-auto {
  gap: auto;
}

.w-auto {
  width: auto;
}

.w-full {
  width: 100%;
}

.h-auto {
  height: auto;
}

.h-full {
  height: 100%;
}

.flex {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: nowrap;
}

.column {
  flex-direction: column;
}

.column-reverse {
  flex-direction: column-reverse;
}

.row {
  flex-direction: row;
}

.row-reverse {
  flex-direction: row-reverse;
}

.align-start {
  align-items: flex-start;
}

.align-center {
  align-items: center;
}

.align-end {
  align-items: flex-end;
}

.align-baseline {
  align-items: baseline;
}

.align-stretch {
  align-items: stretch;
}

.justify-start {
  justify-content: flex-start;
}

.justify-center {
  justify-content: center;
}

.justify-end {
  justify-content: flex-end;
}

.justify-between {
  justify-content: space-between;
}

.justify-around {
  justify-content: space-around;
}

.justify-evenly {
  justify-content: space-evenly;
}

.wrap {
  flex-wrap: wrap;
}

.nowrap {
  flex-wrap: nowrap;
}

.wrap-reverse {
  flex-wrap: wrap-reverse;
}

.grow-0 {
  flex-grow: 0;
}

.grow-1 {
  flex-grow: 1;
}

.shrink-0 {
  flex-shrink: 0;
}

.shrink-1 {
  flex-shrink: 1;
}

.basis-auto {
  flex-basis: auto;
}

.basis-0 {
  flex-basis: 0;
}

.flex-auto {
  flex: 1 1 auto;
}

.flex-none {
  flex: none;
}

.order-first {
  order: -1;
}

.order-last {
  order: 1;
}

.order-0 {
  order: 0;
}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}

.order-3 {
  order: 3;
}

.order-4 {
  order: 4;
}

.order-5 {
  order: 5;
}

.flex-1 {
  flex: 1 1;
}

.grid {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-template-rows: repeat(1, 1fr);
  grid-auto-flow: row;
}

.grid-cols-1 {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-template-rows: repeat(1, 1fr);
  grid-auto-flow: row;
}

.grid-cols-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(1, 1fr);
  grid-auto-flow: row;
}

.grid-cols-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(1, 1fr);
  grid-auto-flow: row;
}

.grid-cols-4 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(1, 1fr);
  grid-auto-flow: row;
}

.grid-cols-5 {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(1, 1fr);
  grid-auto-flow: row;
}

.grid-cols-6 {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: repeat(1, 1fr);
  grid-auto-flow: row;
}

.grid-cols-7 {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: repeat(1, 1fr);
  grid-auto-flow: row;
}

.grid-cols-8 {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  grid-template-rows: repeat(1, 1fr);
  grid-auto-flow: row;
}

.grid-cols-auto {
  display: grid;
  grid-template-columns: repeat(auto-fill, 1fr);
  grid-template-rows: repeat(1, 1fr);
  grid-auto-flow: minmax(100px, 1fr);
}

.grid-rows-1 {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-template-rows: repeat(1, 1fr);
  grid-auto-flow: row;
}

.grid-rows-2 {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-auto-flow: row;
}

.grid-rows-3 {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-template-rows: repeat(3, 1fr);
  grid-auto-flow: row;
}

.grid-rows-auto {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-template-rows: repeat(auto-fill, 1fr);
  grid-auto-flow: minmax(100px, 1fr);
}

.grid-auto-flow-row {
  grid-auto-flow: row;
}

.grid-auto-flow-column {
  grid-auto-flow: column;
}

.grid-auto-flow-dense {
  grid-auto-flow: dense;
}

.formio-form nav {
  display: none;
}

.logo-img {
  width: 100%;
  max-width: 600px;
}

.home-holder h2 {
  font-size: 48px;
}

.home-holder p, .home-holder div {
  font-size: 20px;
}

.btn-wizard-nav-submit {
  display: none;
}

.home-holder button, .btn-wizard-nav-next, .home-holder button:hover {
  background-color: black;
  font-size: 18px;
  border-radius: 7px;
  padding: 10px;
  border: 1px solid transparent;
  color: white;
  cursor: pointer;
  align-self: flex-end;
  margin-top: 20px;
  font-weight: 900;
}

.home-holder select {
  display: block;
  height: 40px;
  padding: 6px 12px;
  color: rgb(85, 85, 85);
  background-color: rgb(255, 255, 255);
  background-image: none;
  border: 1px solid rgb(204, 204, 204);
  border-radius: 4px;
  box-shadow: rgba(0, 0, 0, 0.075) 0px 1px 1px inset;
  margin-bottom: 0px;
  font-size: 20px;
  margin-top: 10px;
}

nav a {
  color: rgb(51, 122, 183);
  text-decoration: none;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
}

.home-holder form > div:last-child {
  height: 116px;
}

.home-holder > p:last-child {
  font-size: 16px;
  margin-top: 50px;
}

nav > p {
  font: 12px;
}

.offerhome {
  width: 300px;
  float: right;
  margin-bottom: -27px;
}

.formio-component-zusammenfassungDesAuftrags {
  font-size: 11px;
}

@media (max-width: 800px) {
  .offerhome {
    width: 200px;
    float: right;
    margin-bottom: -27px;
  }
  .home-holder h2 {
    font-size: 21px;
  }
  .home-holder p, .home-holder div, .home-holder label {
    font-size: 12px;
  }
  .home-holder button, .home-holder button:hover {
    margin: 20px auto;
    float: none;
    background-color: black;
    font-size: 12px;
    border-radius: 7px;
    padding: 5px;
    border: 1px solid transparent;
    color: white;
    cursor: pointer;
    align-self: flex-end;
    font-weight: 900;
    width: 100%;
  }
  nav a {
    color: rgb(51, 122, 183);
    text-decoration: none;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 10px;
  }
  .home-holder select {
    display: block;
    height: 24px;
    padding: 2px 5px;
    margin-top: 5px;
    color: rgb(85, 85, 85);
    background-color: rgb(255, 255, 255);
    background-image: none;
    border: 1px solid rgb(204, 204, 204);
    border-radius: 4px;
    box-shadow: rgba(0, 0, 0, 0.075) 0px 1px 1px inset;
    margin-bottom: 0px;
    font-size: 11px;
  }
  .home-holder > p:last-child {
    font-size: 10px;
    margin-top: 30px;
  }
  .home-holder form > div:last-child {
    height: 68px;
  }
  nav > p {
    font-size: 9px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/utilities/_colors.scss","webpack://./src/styles/main.scss","webpack://./src/styles/utilities/_spacing.scss","webpack://./src/styles/utilities/_flex-grid-utilities.scss"],"names":[],"mappings":"AA+GA;EAEE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,iCAAA;EACA,kDAAA;EACA,2BAAA;EACA,4BAAA;EACA,yBAAA;EACA,yBAAA;EACA,mCAAA;EACA,iCAAA;EACA,2BAAA;EACA,0BAAA;EACA,4BAAA;EACA,0BAAA;EACA,6BAAA;EACA,8BAAA;EACA,6BAAA;EACA,+BAAA;EACA,iCAAA;EACA,8BAAA;EACA,8BAAA;EACA,gCAAA;EACA,iCAAA;EACA,gCAAA;EACA,yBAAA;EACA,iCAAA;EACA,iCAAA;EACA,gCAAA;EACA,gCAAA;EACA,0BAAA;EACA,4BAAA;EACA,2BAAA;EACA,6BAAA;EACA,6BAAA;EACA,+BAAA;EACA,2BAAA;EACA,+BAAA;EACA,gCAAA;EACA,8BAAA;EACA,6BAAA;EACA,sBAAA;EACA,uBAAA;EAGA,4BAAA;EACA,4BAAA;EACA,6BAAA;EACA,sCAAA;EACA,sDAAA;EACA,gCAAA;EACA,iCAAA;EACA,8BAAA;EACA,8BAAA;EACA,wCAAA;EACA,sCAAA;EACA,gCAAA;EACA,+BAAA;EACA,iCAAA;EACA,+BAAA;EACA,kCAAA;EACA,mCAAA;EACA,kCAAA;EACA,oCAAA;EACA,sCAAA;EACA,mCAAA;EACA,mCAAA;EACA,qCAAA;EACA,sCAAA;EACA,qCAAA;EACA,8BAAA;EACA,sCAAA;EACA,sCAAA;EACA,qCAAA;EACA,qCAAA;EACA,+BAAA;EACA,iCAAA;EACA,gCAAA;EACA,kCAAA;EACA,kCAAA;EACA,oCAAA;EACA,gCAAA;EACA,oCAAA;EACA,qCAAA;EACA,mCAAA;EACA,kCAAA;EACA,2BAAA;EACA,4BAAA;AC/GF;;AC/EE;EACE,WAAA;ADkFJ;;AChFE;EACE,wBAAA;ADmFJ;;ACjFE;EACE,sBAAA;ADoFJ;;AClFE;EACE,eAAA;ADqFJ;;ACnFE;EACE,kBAAA;ADsFJ;;ACpFE;EACE,kBAAA;ADuFJ;;ACrFE;EACE,iBAAA;ADwFJ;;AC3GE;EACE,YAAA;AD8GJ;;AC5GE;EACE,yBAAA;AD+GJ;;AC7GE;EACE,uBAAA;ADgHJ;;AC9GE;EACE,gBAAA;ADiHJ;;AC/GE;EACE,mBAAA;ADkHJ;;AChHE;EACE,mBAAA;ADmHJ;;ACjHE;EACE,kBAAA;ADoHJ;;ACvIE;EACE,YAAA;AD0IJ;;ACxIE;EACE,yBAAA;AD2IJ;;ACzIE;EACE,uBAAA;AD4IJ;;AC1IE;EACE,gBAAA;AD6IJ;;AC3IE;EACE,mBAAA;AD8IJ;;AC5IE;EACE,mBAAA;AD+IJ;;AC7IE;EACE,kBAAA;ADgJJ;;ACnKE;EACE,YAAA;ADsKJ;;ACpKE;EACE,yBAAA;ADuKJ;;ACrKE;EACE,uBAAA;ADwKJ;;ACtKE;EACE,gBAAA;ADyKJ;;ACvKE;EACE,mBAAA;AD0KJ;;ACxKE;EACE,mBAAA;AD2KJ;;ACzKE;EACE,kBAAA;AD4KJ;;AC/LE;EACE,YAAA;ADkMJ;;AChME;EACE,yBAAA;ADmMJ;;ACjME;EACE,uBAAA;ADoMJ;;AClME;EACE,gBAAA;ADqMJ;;ACnME;EACE,mBAAA;ADsMJ;;ACpME;EACE,mBAAA;ADuMJ;;ACrME;EACE,kBAAA;ADwMJ;;AC3NE;EACE,YAAA;AD8NJ;;AC5NE;EACE,yBAAA;AD+NJ;;AC7NE;EACE,uBAAA;ADgOJ;;AC9NE;EACE,gBAAA;ADiOJ;;AC/NE;EACE,mBAAA;ADkOJ;;AChOE;EACE,mBAAA;ADmOJ;;ACjOE;EACE,kBAAA;ADoOJ;;ACvPE;EACE,YAAA;AD0PJ;;ACxPE;EACE,yBAAA;AD2PJ;;ACzPE;EACE,uBAAA;AD4PJ;;AC1PE;EACE,gBAAA;AD6PJ;;AC3PE;EACE,mBAAA;AD8PJ;;AC5PE;EACE,mBAAA;AD+PJ;;AC7PE;EACE,kBAAA;ADgQJ;;ACnRE;EACE,YAAA;ADsRJ;;ACpRE;EACE,yBAAA;ADuRJ;;ACrRE;EACE,uBAAA;ADwRJ;;ACtRE;EACE,gBAAA;ADyRJ;;ACvRE;EACE,mBAAA;AD0RJ;;ACxRE;EACE,mBAAA;AD2RJ;;ACzRE;EACE,kBAAA;AD4RJ;;AC/SE;EACE,YAAA;ADkTJ;;AChTE;EACE,yBAAA;ADmTJ;;ACjTE;EACE,uBAAA;ADoTJ;;AClTE;EACE,gBAAA;ADqTJ;;ACnTE;EACE,mBAAA;ADsTJ;;ACpTE;EACE,mBAAA;ADuTJ;;ACrTE;EACE,kBAAA;ADwTJ;;AC3UE;EACE,YAAA;AD8UJ;;AC5UE;EACE,yBAAA;AD+UJ;;AC7UE;EACE,uBAAA;ADgVJ;;AC9UE;EACE,gBAAA;ADiVJ;;AC/UE;EACE,mBAAA;ADkVJ;;AChVE;EACE,mBAAA;ADmVJ;;ACjVE;EACE,kBAAA;ADoVJ;;ACvWE;EACE,aAAA;AD0WJ;;ACxWE;EACE,0BAAA;AD2WJ;;ACzWE;EACE,wBAAA;AD4WJ;;AC1WE;EACE,iBAAA;AD6WJ;;AC3WE;EACE,oBAAA;AD8WJ;;AC5WE;EACE,oBAAA;AD+WJ;;AC7WE;EACE,mBAAA;ADgXJ;;ACnYE;EACE,aAAA;ADsYJ;;ACpYE;EACE,0BAAA;ADuYJ;;ACrYE;EACE,wBAAA;ADwYJ;;ACtYE;EACE,iBAAA;ADyYJ;;ACvYE;EACE,oBAAA;AD0YJ;;ACxYE;EACE,oBAAA;AD2YJ;;ACzYE;EACE,mBAAA;AD4YJ;;AC/ZE;EACE,aAAA;ADkaJ;;AChaE;EACE,0BAAA;ADmaJ;;ACjaE;EACE,wBAAA;ADoaJ;;AClaE;EACE,iBAAA;ADqaJ;;ACnaE;EACE,oBAAA;ADsaJ;;ACpaE;EACE,oBAAA;ADuaJ;;ACraE;EACE,mBAAA;ADwaJ;;ACnaA;EACE,iBAAA;ADsaF;;ACpaA;EACE,kBAAA;ADuaF;;ACraA;EACE,gBAAA;ADwaF;;ACtaA;EACE,mBAAA;ADyaF;;ACvaA;EACE,mBAAA;AD0aF;;ACxaA;EACE,kBAAA;AD2aF;;ACzaA;EACE,YAAA;AD4aF;;ACzaA;EACE,cAAA;AD4aF;;AC1aA;EACE,eAAA;AD6aF;;AC3aA;EACE,aAAA;AD8aF;;AC5aA;EACE,gBAAA;AD+aF;;AC7aA;EACE,gBAAA;ADgbF;;AC9aA;EACE,eAAA;ADibF;;AC5aE;EACE,YAAA;AD+aJ;;AC7aE;EACE,yBAAA;ADgbJ;;AC9aE;EACE,uBAAA;ADibJ;;AC/aE;EACE,gBAAA;ADkbJ;;AChbE;EACE,mBAAA;ADmbJ;;ACjbE;EACE,mBAAA;ADobJ;;AClbE;EACE,kBAAA;ADqbJ;;ACxcE;EACE,aAAA;AD2cJ;;ACzcE;EACE,0BAAA;AD4cJ;;AC1cE;EACE,wBAAA;AD6cJ;;AC3cE;EACE,iBAAA;AD8cJ;;AC5cE;EACE,oBAAA;AD+cJ;;AC7cE;EACE,oBAAA;ADgdJ;;AC9cE;EACE,mBAAA;ADidJ;;ACpeE;EACE,aAAA;ADueJ;;ACreE;EACE,0BAAA;ADweJ;;ACteE;EACE,wBAAA;ADyeJ;;ACveE;EACE,iBAAA;AD0eJ;;ACxeE;EACE,oBAAA;AD2eJ;;ACzeE;EACE,oBAAA;AD4eJ;;AC1eE;EACE,mBAAA;AD6eJ;;AChgBE;EACE,aAAA;ADmgBJ;;ACjgBE;EACE,0BAAA;ADogBJ;;AClgBE;EACE,wBAAA;ADqgBJ;;ACngBE;EACE,iBAAA;ADsgBJ;;ACpgBE;EACE,oBAAA;ADugBJ;;ACrgBE;EACE,oBAAA;ADwgBJ;;ACtgBE;EACE,mBAAA;ADygBJ;;AC5hBE;EACE,aAAA;AD+hBJ;;AC7hBE;EACE,0BAAA;ADgiBJ;;AC9hBE;EACE,wBAAA;ADiiBJ;;AC/hBE;EACE,iBAAA;ADkiBJ;;AChiBE;EACE,oBAAA;ADmiBJ;;ACjiBE;EACE,oBAAA;ADoiBJ;;ACliBE;EACE,mBAAA;ADqiBJ;;ACxjBE;EACE,aAAA;AD2jBJ;;ACzjBE;EACE,0BAAA;AD4jBJ;;AC1jBE;EACE,wBAAA;AD6jBJ;;AC3jBE;EACE,iBAAA;AD8jBJ;;AC5jBE;EACE,oBAAA;AD+jBJ;;AC7jBE;EACE,oBAAA;ADgkBJ;;AC9jBE;EACE,mBAAA;ADikBJ;;ACplBE;EACE,aAAA;ADulBJ;;ACrlBE;EACE,0BAAA;ADwlBJ;;ACtlBE;EACE,wBAAA;ADylBJ;;ACvlBE;EACE,iBAAA;AD0lBJ;;ACxlBE;EACE,oBAAA;AD2lBJ;;ACzlBE;EACE,oBAAA;AD4lBJ;;AC1lBE;EACE,mBAAA;AD6lBJ;;AChnBE;EACE,aAAA;ADmnBJ;;ACjnBE;EACE,0BAAA;ADonBJ;;AClnBE;EACE,wBAAA;ADqnBJ;;ACnnBE;EACE,iBAAA;ADsnBJ;;ACpnBE;EACE,oBAAA;ADunBJ;;ACrnBE;EACE,oBAAA;ADwnBJ;;ACtnBE;EACE,mBAAA;ADynBJ;;AC5oBE;EACE,aAAA;AD+oBJ;;AC7oBE;EACE,0BAAA;ADgpBJ;;AC9oBE;EACE,wBAAA;ADipBJ;;AC/oBE;EACE,iBAAA;ADkpBJ;;AChpBE;EACE,oBAAA;ADmpBJ;;ACjpBE;EACE,oBAAA;ADopBJ;;AClpBE;EACE,mBAAA;ADqpBJ;;ACxqBE;EACE,aAAA;AD2qBJ;;ACzqBE;EACE,0BAAA;AD4qBJ;;AC1qBE;EACE,wBAAA;AD6qBJ;;AC3qBE;EACE,iBAAA;AD8qBJ;;AC5qBE;EACE,oBAAA;AD+qBJ;;AC7qBE;EACE,oBAAA;ADgrBJ;;AC9qBE;EACE,mBAAA;ADirBJ;;ACpsBE;EACE,cAAA;ADusBJ;;ACrsBE;EACE,2BAAA;ADwsBJ;;ACtsBE;EACE,yBAAA;ADysBJ;;ACvsBE;EACE,kBAAA;AD0sBJ;;ACxsBE;EACE,qBAAA;AD2sBJ;;ACzsBE;EACE,qBAAA;AD4sBJ;;AC1sBE;EACE,oBAAA;AD6sBJ;;AChuBE;EACE,cAAA;ADmuBJ;;ACjuBE;EACE,2BAAA;ADouBJ;;ACluBE;EACE,yBAAA;ADquBJ;;ACnuBE;EACE,kBAAA;ADsuBJ;;ACpuBE;EACE,qBAAA;ADuuBJ;;ACruBE;EACE,qBAAA;ADwuBJ;;ACtuBE;EACE,oBAAA;ADyuBJ;;AC5vBE;EACE,cAAA;AD+vBJ;;AC7vBE;EACE,2BAAA;ADgwBJ;;AC9vBE;EACE,yBAAA;ADiwBJ;;AC/vBE;EACE,kBAAA;ADkwBJ;;AChwBE;EACE,qBAAA;ADmwBJ;;ACjwBE;EACE,qBAAA;ADowBJ;;AClwBE;EACE,oBAAA;ADqwBJ;;AChwBA;EACE,kBAAA;ADmwBF;;ACjwBA;EACE,mBAAA;ADowBF;;AClwBA;EACE,iBAAA;ADqwBF;;ACnwBA;EACE,oBAAA;ADswBF;;ACpwBA;EACE,oBAAA;ADuwBF;;ACrwBA;EACE,mBAAA;ADwwBF;;ACtwBA;EACE,aAAA;ADywBF;;ACtwBA;EACE,eAAA;ADywBF;;ACvwBA;EACE,gBAAA;AD0wBF;;ACxwBA;EACE,cAAA;AD2wBF;;ACzwBA;EACE,iBAAA;AD4wBF;;AC1wBA;EACE,iBAAA;AD6wBF;;AC3wBA;EACE,gBAAA;AD8wBF;;ACzwBE;EACE,QAAA;AD4wBJ;;AC7wBE;EACE,SAAA;ADgxBJ;;ACjxBE;EACE,SAAA;ADoxBJ;;ACrxBE;EACE,SAAA;ADwxBJ;;ACzxBE;EACE,SAAA;AD4xBJ;;AC7xBE;EACE,SAAA;ADgyBJ;;ACjyBE;EACE,SAAA;ADoyBJ;;ACryBE;EACE,SAAA;ADwyBJ;;ACzyBE;EACE,SAAA;AD4yBJ;;AC7yBE;EACE,SAAA;ADgzBJ;;ACjzBE;EACE,UAAA;ADozBJ;;ACrzBE;EACE,UAAA;ADwzBJ;;ACzzBE;EACE,UAAA;AD4zBJ;;ACvzBA;EACE,SAAA;AD0zBF;;ACvzBA;EACE,WAAA;AD0zBF;;ACvzBA;EACE,WAAA;AD0zBF;;ACvzBA;EACE,YAAA;AD0zBF;;ACvzBA;EACE,YAAA;AD0zBF;;AEx6BA;EAjDE,aAAA;EACA,mBAiDc;EAhDd,2BAgDmB;EA/CnB,uBA+C+B;EA9C/B,iBA8C2C;AF+6B7C;;AE76BA;EA3CE,sBA4CwB;AFg7B1B;;AE96BA;EA9CE,8BA+CwB;AFi7B1B;;AE/6BA;EAjDE,mBAkDwB;AFk7B1B;;AEh7BA;EApDE,2BAqDwB;AFm7B1B;;AEh7BA;EA1CE,uBA2CqB;AFm7BvB;;AEj7BA;EA7CE,mBA8CqB;AFo7BvB;;AEl7BA;EAhDE,qBAiDqB;AFq7BvB;;AEn7BA;EAnDE,qBAoDqB;AFs7BvB;;AEp7BA;EAtDE,oBAuDqB;AFu7BvB;;AEp7BA;EA/DE,2BAgEyB;AFu7B3B;;AEr7BA;EAlEE,uBAmEyB;AFw7B3B;;AEt7BA;EArEE,yBAsEyB;AFy7B3B;;AEv7BA;EAxEE,8BAyEyB;AF07B3B;;AEx7BA;EA3EE,6BA4EyB;AF27B3B;;AEz7BA;EA9EE,6BA+EyB;AF47B3B;;AEz7BA;EAvFE,eAwFmB;AF47BrB;;AE17BA;EA1FE,iBA2FmB;AF67BrB;;AE37BA;EA7FE,uBA8FmB;AF87BrB;;AE37BA;EAlFE,YAmFmB;AF87BrB;;AE57BA;EArFE,YAsFmB;AF+7BrB;;AE77BA;EApFE,cAqFqB;AFg8BvB;;AE97BA;EAvFE,cAwFqB;AFi8BvB;;AE97BA;EAvFE,gBAwFoB;AFi8BtB;;AE/7BA;EA1FE,aA2FoB;AFk8BtB;;AE/7BA;EACE,cAAA;AFk8BF;;AEh8BA;EACE,UAAA;AFm8BF;;AEh8BA;EACE,SAAA;AFm8BF;;AEj8BA;EACE,QAAA;AFo8BF;;AEl8BA;EACE,QAAA;AFq8BF;;AEn8BA;EACE,QAAA;AFs8BF;;AEp8BA;EACE,QAAA;AFu8BF;;AEr8BA;EACE,QAAA;AFw8BF;;AEt8BA;EACE,QAAA;AFy8BF;;AEv8BA;EACE,QAAA;AF08BF;;AEv8BA;EACE,SAAA;AF08BF;;AEt8BA;EA7HE,aAAA;EACA,qCAAA;EACA,kCAAA;EACA,mBAJyC;AF2kC3C;;AE18BA;EAhIE,aAAA;EACA,qCAAA;EACA,kCAAA;EACA,mBAJyC;AFklC3C;;AE98BA;EAnIE,aAAA;EACA,qCAAA;EACA,kCAAA;EACA,mBAJyC;AFylC3C;;AEl9BA;EAtIE,aAAA;EACA,qCAAA;EACA,kCAAA;EACA,mBAJyC;AFgmC3C;;AEt9BA;EAzIE,aAAA;EACA,qCAAA;EACA,kCAAA;EACA,mBAJyC;AFumC3C;;AE19BA;EA5IE,aAAA;EACA,qCAAA;EACA,kCAAA;EACA,mBAJyC;AF8mC3C;;AE99BA;EA/IE,aAAA;EACA,qCAAA;EACA,kCAAA;EACA,mBAJyC;AFqnC3C;;AEl+BA;EAlJE,aAAA;EACA,qCAAA;EACA,kCAAA;EACA,mBAJyC;AF4nC3C;;AEt+BA;EArJE,aAAA;EACA,qCAAA;EACA,kCAAA;EACA,mBAJyC;AFmoC3C;;AEz+BA;EAzJE,aAAA;EACA,6CAAA;EACA,kCAAA;EACA,kCAuJ4B;AF++B9B;;AE5+BA;EA7JE,aAAA;EACA,qCAAA;EACA,kCAAA;EACA,mBAJyC;AFipC3C;;AEh/BA;EAhKE,aAAA;EACA,qCAAA;EACA,kCAAA;EACA,mBAJyC;AFwpC3C;;AEp/BA;EAnKE,aAAA;EACA,qCAAA;EACA,kCAAA;EACA,mBAJyC;AF+pC3C;;AEv/BA;EAvKE,aAAA;EACA,qCAAA;EACA,0CAAA;EACA,kCAqK4B;AF6/B9B;;AE1/BA;EACE,mBAAA;AF6/BF;;AE3/BA;EACE,sBAAA;AF8/BF;;AE5/BA;EACE,qBAAA;AF+/BF;;AA1tCA;EACI,aAAA;AA6tCJ;;AA3tCA;EACI,WAAA;EACA,gBAAA;AA8tCJ;;AA3tCA;EACI,eAAA;AA8tCJ;;AA5tCA;EACI,eAAA;AA+tCJ;;AA7tCA;EACI,aAAA;AAguCJ;;AA9tCA;EACI,uBAAA;EAAyB,eAAA;EAAiB,kBAAA;EAAoB,aAAA;EAAe,6BAAA;EAA+B,YAAA;EAAc,eAAA;EAAiB,oBAAA;EAAsB,gBAAA;EAAkB,gBAAA;AA0uCvL;;AAtuCA;EACI,cAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,oCAAA;EACA,sBAAA;EACA,oCAAA;EACA,kBAAA;EACA,kDAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAyuCJ;;AAvuCA;EACI,wBAAA;EACA,qBAAA;EACA,2DAAA;EACA,eAAA;AA0uCJ;;AAvuCA;EACI,aAAA;AA0uCJ;;AAxuCA;EACI,eAAA;EACA,gBAAA;AA2uCJ;;AAzuCA;EACI,UAAA;AA4uCJ;;AA1uCA;EACI,YAAA;EACA,YAAA;EACA,oBAAA;AA6uCJ;;AA3uCA;EACI,eAAA;AA8uCJ;;AA5uCA;EAEI;IACI,YAAA;IACA,YAAA;IACA,oBAAA;EA8uCN;EA5uCE;IACI,eAAA;EA8uCN;EA5uCE;IACI,eAAA;EA8uCN;EA5uCE;IACI,iBAAA;IAAkB,WAAA;IAAa,uBAAA;IAAyB,eAAA;IAAiB,kBAAA;IAAoB,YAAA;IAAc,6BAAA;IAA+B,YAAA;IAAc,eAAA;IAAiB,oBAAA;IAAsB,gBAAA;IAC/L,WAAA;EAwvCN;EAtvCE;IACI,wBAAA;IACA,qBAAA;IACA,2DAAA;IACA,eAAA;EAwvCN;EAtvCE;IACI,cAAA;IACA,YAAA;IACA,gBAAA;IACA,eAAA;IACA,sBAAA;IACA,oCAAA;IACA,sBAAA;IACA,oCAAA;IACA,kBAAA;IACA,kDAAA;IACA,kBAAA;IACA,eAAA;EAwvCN;EAtvCE;IACA,eAAA;IACA,gBAAA;EAwvCF;EAtvCE;IACI,YAAA;EAwvCN;EAtvCE;IACI,cAAA;EAwvCN;AACF","sourcesContent":["// Light Theme Colors\n$light-Primary-Main: #ce8f00;\n$light-Primary-Dark: #475467;\n$light-Primary-Light: #d8d8dc;\n$light-Primary-Gradient-Start: #f5d793;\n$light-Primary-Gradient-End: #fcaf00;\n$light-Primary-SemiDark: #ccc2ab;\n$light-Primary-SemiLight: #8c7030;\n\n$light-Secondary-Main: #3982f8;\n$light-Secondary-Pale: #ceebf5;\n$light-Secondary-Gradient-Start: #f5d793;\n$light-Secondary-Gradient-End: #005d7b;\n\n$light-Neutral-BG-Light: #ffffff;\n$light-Neutral-BG-Dark: #e0dbce;\n$light-Neutral-BG-Shadow: #000000;\n$light-Neutral-BG-Main: #f5f5f5;\n$light-Neutral-BG-Shadow2: #1b1b1b;\n$light-Neutral-BG-Backdrop: #333333;\n\n$light-Neutral-Text-Title: #290905;\n$light-Neutral-Text-Caption: #827d7c;\n$light-Neutral-Text-CaptionT2: #6b6862;\n$light-Neutral-Text-Title2: #291d05;\n$light-Neutral-Text-Title3: #ffffff;\n\n$light-Semantic-Success-Main: #42b778;\n$light-Semantic-Success-Light: #96fda0;\n$light-Semantic-Success-Pale: #ecfdf3;\n\n$light-Semantic-Error: #e05151;\n\n$light-Semantic-Progress-Main: #344054;\n$light-Semantic-Progress-Pale: #f2f4f7;\n\n$light-Warning-Progress-Main: #ce8f00;\n$light-Warning-Progress-Pale: #fffaeb;\n\n$light-ColorPallet-Red: #eb5757;\n$light-ColorPallet-Green: #27ae60;\n$light-ColorPallet-Blue: #2d9cdb;\n$light-ColorPallet-Yellow: #f2c94c;\n\n$light-ColorPallet-Orange: #f2994a;\n$light-ColorPallet-BabyBlue: #d3ebff;\n$light-ColorPallet-Pink: #db2daa;\n$light-ColorPallet-Irancell: #ffcb05;\n$light-ColorPallet-Irancell2: #291d05;\n$light-ColorPallet-PaleRed: #eed4d3;\n$light-ColorPallet-Purple: #ad64cb;\n\n$light-Others-Gray: #fcfcfd;\n$light-Others-Gray2: #eaecf0;\n\n// Dark Theme Colors\n$dark-Primary-Main: #fcce65;\n$dark-Primary-Dark: #b88b25;\n$dark-Primary-Light: #403f3c;\n$dark-Primary-Gradient-Start: #f3dfb2;\n$dark-Primary-Gradient-End: #d6af59;\n$dark-Primary-SemiDark: #ccc2ab;\n$dark-Primary-SemiLight: #8c7030;\n\n$dark-Secondary-Main: #3295b6;\n$dark-Secondary-Pale: #ceebf5;\n$dark-Secondary-Gradient-Start: #1bafdf;\n$dark-Secondary-Gradient-End: #005d7b;\n\n$dark-Neutral-BG-Light: #333333;\n$dark-Neutral-BG-Dark: #262626;\n$dark-Neutral-BG-Shadow: #e4e2e2;\n$dark-Neutral-BG-Main: #1e1e1e;\n$dark-Neutral-BG-Shadow2: #282828;\n$dark-Neutral-BG-Backdrop: #0a0a0a;\n\n$dark-Neutral-Text-Title: #f7f7f5;\n$dark-Neutral-Text-Caption: #c0c0c0;\n$dark-Neutral-Text-CaptionT2: #d7d7d7;\n$dark-Neutral-Text-Title2: #080a0a;\n$dark-Neutral-Text-Title3: #ffffff;\n\n$dark-Semantic-Success-Main: #66b78c;\n$dark-Semantic-Success-Light: #c8fdcd;\n$dark-Semantic-Success-Pale: #ecfdf3;\n\n$dark-Semantic-Error: #e07e7e;\n\n$dark-Semantic-Progress-Main: #344054;\n$dark-Semantic-Progress-Pale: #f2f4f7;\n\n$dark-Warning-Progress-Main: #ce8f00;\n$dark-Warning-Progress-Pale: #fffaeb;\n\n$dark-ColorPallet-Red: #fc8d8d;\n$dark-ColorPallet-Green: #49ae74;\n$dark-ColorPallet-Blue: #5aacdb;\n$dark-ColorPallet-Yellow: #f2d57b;\n\n$dark-ColorPallet-Orange: #f2b37b;\n$dark-ColorPallet-BabyBlue: #d3ebff;\n$dark-ColorPallet-Pink: #db5ab7;\n$dark-ColorPallet-Irancell: #ffcb05;\n$dark-ColorPallet-Irancell2: #ffcb05;\n$dark-ColorPallet-PaleRed: #eed4d3;\n$dark-ColorPallet-Purple: #b98ccb;\n\n$dark-Others-Gray: #fcfcfd;\n$dark-Others-Gray2: #eaecf0;\n\n// Dynamic Colors for CSS Custom Properties\n:root {\n  // Light Theme\n  --Primary-Main: #{$light-Primary-Main};\n  --Primary-Dark: #{$light-Primary-Dark};\n  --Primary-Light: #{$light-Primary-Light};\n  --Primary-Gradient-Start: #{$light-Primary-Gradient-Start};\n  --Primary-Gradient-End: #{light-Primary-Gradient-End};\n  --Primary-SemiDark: #{$light-Primary-SemiDark};\n  --Primary-SemiLight: #{$light-Primary-SemiLight};\n  --Secondary-Main: #{$light-Secondary-Main};\n  --Secondary-Pale: #{$light-Secondary-Pale};\n  --Secondary-Gradient-Start: #{$light-Secondary-Gradient-Start};\n  --Secondary-Gradient-End: #{$light-Secondary-Gradient-End};\n  --Neutral-BG-Light: #{$light-Neutral-BG-Light};\n  --Neutral-BG-Dark: #{$light-Neutral-BG-Dark};\n  --Neutral-BG-Shadow: #{$light-Neutral-BG-Shadow};\n  --Neutral-BG-Main: #{$light-Neutral-BG-Main};\n  --Neutral-BG-Shadow2: #{$light-Neutral-BG-Shadow2};\n  --Neutral-BG-Backdrop: #{$light-Neutral-BG-Backdrop};\n  --Neutral-Text-Title: #{$light-Neutral-Text-Title};\n  --Neutral-Text-Caption: #{$light-Neutral-Text-Caption};\n  --Neutral-Text-CaptionT2: #{$light-Neutral-Text-CaptionT2};\n  --Neutral-Text-Title2: #{$light-Neutral-Text-Title2};\n  --Neutral-Text-Title3: #{$light-Neutral-Text-Title3};\n  --Semantic-Success-Main: #{$light-Semantic-Success-Main};\n  --Semantic-Success-Light: #{$light-Semantic-Success-Light};\n  --Semantic-Success-Pale: #{$light-Semantic-Success-Pale};\n  --Semantic-Error: #{$light-Semantic-Error};\n  --Semantic-Progress-Main: #{$light-Semantic-Progress-Main};\n  --Semantic-Progress-Pale: #{$light-Semantic-Progress-Pale};\n  --Warning-Progress-Main: #{$light-Warning-Progress-Main};\n  --Warning-Progress-Pale: #{$light-Warning-Progress-Pale};\n  --ColorPallet-Red: #{$light-ColorPallet-Red};\n  --ColorPallet-Green: #{$light-ColorPallet-Green};\n  --ColorPallet-Blue: #{$light-ColorPallet-Blue};\n  --ColorPallet-Yellow: #{$light-ColorPallet-Yellow};\n  --ColorPallet-Orange: #{$light-ColorPallet-Orange};\n  --ColorPallet-BabyBlue: #{$light-ColorPallet-BabyBlue};\n  --ColorPallet-Pink: #{$light-ColorPallet-Pink};\n  --ColorPallet-Irancell: #{$light-ColorPallet-Irancell};\n  --ColorPallet-Irancell2: #{$light-ColorPallet-Irancell2};\n  --ColorPallet-PaleRed: #{$light-ColorPallet-PaleRed};\n  --ColorPallet-Purple: #{$light-ColorPallet-Purple};\n  --Others-Gray: #{$light-Others-Gray};\n  --Others-Gray2: #{$light-Others-Gray2};\n\n  // Dark Theme\n  --dark-Primary-Main: #{$dark-Primary-Main};\n  --dark-Primary-Dark: #{$dark-Primary-Dark};\n  --dark-Primary-Light: #{$dark-Primary-Light};\n  --dark-Primary-Gradient-Start: #{$dark-Primary-Gradient-Start};\n  --dark-Primary-Gradient-End: #{dark-Primary-Gradient-End};\n  --dark-Primary-SemiDark: #{$dark-Primary-SemiDark};\n  --dark-Primary-SemiLight: #{$dark-Primary-SemiLight};\n  --dark-Secondary-Main: #{$dark-Secondary-Main};\n  --dark-Secondary-Pale: #{$dark-Secondary-Pale};\n  --dark-Secondary-Gradient-Start: #{$dark-Secondary-Gradient-Start};\n  --dark-Secondary-Gradient-End: #{$dark-Secondary-Gradient-End};\n  --dark-Neutral-BG-Light: #{$dark-Neutral-BG-Light};\n  --dark-Neutral-BG-Dark: #{$dark-Neutral-BG-Dark};\n  --dark-Neutral-BG-Shadow: #{$dark-Neutral-BG-Shadow};\n  --dark-Neutral-BG-Main: #{$dark-Neutral-BG-Main};\n  --dark-Neutral-BG-Shadow2: #{$dark-Neutral-BG-Shadow2};\n  --dark-Neutral-BG-Backdrop: #{$dark-Neutral-BG-Backdrop};\n  --dark-Neutral-Text-Title: #{$dark-Neutral-Text-Title};\n  --dark-Neutral-Text-Caption: #{$dark-Neutral-Text-Caption};\n  --dark-Neutral-Text-CaptionT2: #{$dark-Neutral-Text-CaptionT2};\n  --dark-Neutral-Text-Title2: #{$dark-Neutral-Text-Title2};\n  --dark-Neutral-Text-Title3: #{$dark-Neutral-Text-Title3};\n  --dark-Semantic-Success-Main: #{$dark-Semantic-Success-Main};\n  --dark-Semantic-Success-Light: #{$dark-Semantic-Success-Light};\n  --dark-Semantic-Success-Pale: #{$dark-Semantic-Success-Pale};\n  --dark-Semantic-Error: #{$dark-Semantic-Error};\n  --dark-Semantic-Progress-Main: #{$dark-Semantic-Progress-Main};\n  --dark-Semantic-Progress-Pale: #{$dark-Semantic-Progress-Pale};\n  --dark-Warning-Progress-Main: #{$dark-Warning-Progress-Main};\n  --dark-Warning-Progress-Pale: #{$dark-Warning-Progress-Pale};\n  --dark-ColorPallet-Red: #{$dark-ColorPallet-Red};\n  --dark-ColorPallet-Green: #{$dark-ColorPallet-Green};\n  --dark-ColorPallet-Blue: #{$dark-ColorPallet-Blue};\n  --dark-ColorPallet-Yellow: #{$dark-ColorPallet-Yellow};\n  --dark-ColorPallet-Orange: #{$dark-ColorPallet-Orange};\n  --dark-ColorPallet-BabyBlue: #{$dark-ColorPallet-BabyBlue};\n  --dark-ColorPallet-Pink: #{$dark-ColorPallet-Pink};\n  --dark-ColorPallet-Irancell: #{$dark-ColorPallet-Irancell};\n  --dark-ColorPallet-Irancell2: #{$dark-ColorPallet-Irancell2};\n  --dark-ColorPallet-PaleRed: #{$dark-ColorPallet-PaleRed};\n  --dark-ColorPallet-Purple: #{$dark-ColorPallet-Purple};\n  --dark-Others-Gray: #{$dark-Others-Gray};\n  --dark-Others-Gray2: #{$dark-Others-Gray2};\n}\n","@use \"./utilities/colors\";\n@use \"./utilities/spacing\";\n@use \"./utilities/mixins\";\n@use \"./utilities/flex-grid-utilities\";\n@use \"./utilities/helpers\";\n\n@import \"bootstrap/dist/css/bootstrap.css\";\n@import \"@formio/js/dist/formio.full.min.css\";\n\n.formio-form nav{\n    display: none;\n}\n.logo-img{\n    width: 100%;\n    max-width: 600px;\n}\n\n.home-holder h2{\n    font-size: 48px,\n}\n.home-holder p,.home-holder div{\n    font-size: 20px,\n}\n.btn-wizard-nav-submit{\n    display:none;\n}\n.home-holder button,.btn-wizard-nav-next, .home-holder button:hover{\n    background-color: black; font-size: 18px; border-radius: 7px; padding: 10px; border: 1px solid transparent; color: white; cursor: pointer; align-self: flex-end; margin-top: 20px; font-weight: 900;\n\n}\n\n.home-holder select{\n    display: block;\n    height: 40px;\n    padding: 6px 12px;\n    color: rgb(85, 85, 85);\n    background-color: rgb(255, 255, 255);\n    background-image: none;\n    border: 1px solid rgb(204, 204, 204);\n    border-radius: 4px;\n    box-shadow: rgba(0, 0, 0, 0.075) 0px 1px 1px inset;\n    margin-bottom: 0px;\n    font-size: 20px;\n    margin-top: 10px;\n}\nnav a{\n    color: rgb(51, 122, 183); \n    text-decoration: none; \n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif; \n    font-size: 14px;\n}\n\n.home-holder form > div:last-child{\n    height: 116px;\n}\n.home-holder > p:last-child{\n    font-size: 16px;\n    margin-top: 50px;\n    }\nnav > p{\n    font: 12px;\n}\n.offerhome{\n    width:300px;\n    float: right;\n    margin-bottom: -27px;\n}\n.formio-component-zusammenfassungDesAuftrags {\n    font-size: 11px;\n}\n@media (max-width:800px)  { \n\n    .offerhome{\n        width:200px;\n        float: right;\n        margin-bottom: -27px;\n    }\n    .home-holder h2{\n        font-size: 21px,\n    }\n    .home-holder p,.home-holder div,.home-holder label{\n        font-size: 12px,\n    }\n    .home-holder button,.home-holder button:hover{\n        margin:20px auto; float: none; background-color: black; font-size: 12px; border-radius: 7px; padding: 5px; border: 1px solid transparent; color: white; cursor: pointer; align-self: flex-end; font-weight: 900;\n        width: 100%;\n    }\n    nav a{\n        color: rgb(51, 122, 183); \n        text-decoration: none; \n        font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif; \n        font-size: 10px;\n    }\n    .home-holder select{\n        display: block;\n        height: 24px;\n        padding: 2px 5px;\n        margin-top: 5px;\n        color: rgb(85, 85, 85);\n        background-color: rgb(255, 255, 255);\n        background-image: none;\n        border: 1px solid rgb(204, 204, 204);\n        border-radius: 4px;\n        box-shadow: rgba(0, 0, 0, 0.075) 0px 1px 1px inset;\n        margin-bottom: 0px;\n        font-size: 11px;\n    }\n    .home-holder > p:last-child{\n    font-size: 10px;\n    margin-top: 30px;\n    }\n    .home-holder form > div:last-child{\n        height: 68px;\n    }\n    nav > p{\n        font-size: 9px;\n    }\n}\n\n","// Define base spacing (4px)\n$spacing-unit: 4px;\n\n// Mixin to calculate spacing\n@function spacing($value) {\n  @return $value * 10px;\n}\n\n// Loop for margin utilities\n@for $i from 0 through 12 {\n  .m-#{$i} {\n    margin: spacing($i);\n  }\n  .ml-#{$i} {\n    margin-inline-start: spacing($i);\n  }\n  .mr-#{$i} {\n    margin-inline-end: spacing($i);\n  }\n  .mt-#{$i} {\n    margin-top: spacing($i);\n  }\n  .mb-#{$i} {\n    margin-bottom: spacing($i);\n  }\n  .mx-#{$i} {\n    margin-inline: spacing($i);\n  }\n  .my-#{$i} {\n    margin-block: spacing($i);\n  }\n}\n\n// Loop for margin other utilities\n.ml-auto {\n  margin-left: auto;\n}\n.mr-auto {\n  margin-right: auto;\n}\n.mt-auto {\n  margin-top: auto;\n}\n.mb-auto {\n  margin-bottom: auto;\n}\n.mx-auto {\n  margin-inline: auto;\n}\n.my-auto {\n  margin-block: auto;\n}\n.m-auto {\n  margin: auto;\n}\n\n.ml-0 {\n  margin-left: 0;\n}\n.mr-0 {\n  margin-right: 0;\n}\n.mt-0 {\n  margin-top: 0;\n}\n.mb-0 {\n  margin-bottom: 0;\n}\n.mx-0 {\n  margin-inline: 0;\n}\n.my-0 {\n  margin-block: 0;\n}\n\n// Loop for padding utilities\n@for $i from 0 through 12 {\n  .p-#{$i} {\n    padding: spacing($i);\n  }\n  .pl-#{$i} {\n    padding-inline-start: spacing($i);\n  }\n  .pr-#{$i} {\n    padding-inline-end: spacing($i);\n  }\n  .pt-#{$i} {\n    padding-top: spacing($i);\n  }\n  .pb-#{$i} {\n    padding-bottom: spacing($i);\n  }\n  .px-#{$i} {\n    padding-inline: spacing($i);\n  }\n  .py-#{$i} {\n    padding-block: spacing($i);\n  }\n}\n\n// Loop for padding other utilities\n.pl-auto {\n  padding-left: auto;\n}\n.pr-auto {\n  padding-right: auto;\n}\n.pt-auto {\n  padding-top: auto;\n}\n.pb-auto {\n  padding-bottom: auto;\n}\n.px-auto {\n  padding-inline: auto;\n}\n.py-auto {\n  padding-block: auto;\n}\n.p-auto {\n  padding: auto;\n}\n\n.pl-0 {\n  padding-left: 0;\n}\n.pr-0 {\n  padding-right: 0;\n}\n.pt-0 {\n  padding-top: 0;\n}\n.pb-0 {\n  padding-bottom: 0;\n}\n.px-0 {\n  padding-inline: 0;\n}\n.py-0 {\n  padding-block: 0;\n}\n\n// Loop for gap utilities\n@for $i from 0 through 12 {\n  .gap-#{$i} {\n    gap: spacing($i);\n  }\n}\n\n// Gap other utilities\n.gap-auto {\n  gap: auto;\n}\n\n.w-auto {\n  width: auto;\n}\n\n.w-full {\n  width: 100%;\n}\n\n.h-auto {\n  height: auto;\n}\n\n.h-full {\n  height: 100%;\n}\n","// Flexbox Utility Mixins\n\n@mixin flex(\n  $direction: row,\n  $justify: flex-start,\n  $align: flex-start,\n  $wrap: nowrap\n) {\n  display: flex;\n  flex-direction: $direction;\n  justify-content: $justify;\n  align-items: $align;\n  flex-wrap: $wrap;\n}\n\n// Flexbox Direction Mixins\n@mixin flex-direction($direction) {\n  flex-direction: $direction;\n}\n\n@mixin flex-wrap($wrap) {\n  flex-wrap: $wrap;\n}\n\n// Flexbox Justify Content Mixins\n@mixin justify-content($justify) {\n  justify-content: $justify;\n}\n\n// Flexbox Align Items Mixins\n@mixin align-items($align) {\n  align-items: $align;\n}\n\n// Flexbox Grow/Shrink/Basis Mixins\n@mixin flex-grow($grow) {\n  flex-grow: $grow;\n}\n\n@mixin flex-shrink($shrink) {\n  flex-shrink: $shrink;\n}\n\n@mixin flex-basis($basis) {\n  flex-basis: $basis;\n}\n\n// Grid Utility Mixins\n\n@mixin grid($cols: 1, $rows: 1, $autoFlow: row) {\n  display: grid;\n  grid-template-columns: repeat($cols, 1fr);\n  grid-template-rows: repeat($rows, 1fr);\n  grid-auto-flow: $autoFlow;\n}\n\n// Generate Flexbox Utilities\n.flex {\n  @include flex(row, flex-start, flex-start, nowrap);\n}\n.column {\n  @include flex-direction(column);\n}\n.column-reverse {\n  @include flex-direction(column-reverse);\n}\n.row {\n  @include flex-direction(row);\n}\n.row-reverse {\n  @include flex-direction(row-reverse);\n}\n\n.align-start {\n  @include align-items(flex-start);\n}\n.align-center {\n  @include align-items(center);\n}\n.align-end {\n  @include align-items(flex-end);\n}\n.align-baseline {\n  @include align-items(baseline);\n}\n.align-stretch {\n  @include align-items(stretch);\n}\n\n.justify-start {\n  @include justify-content(flex-start);\n}\n.justify-center {\n  @include justify-content(center);\n}\n.justify-end {\n  @include justify-content(flex-end);\n}\n.justify-between {\n  @include justify-content(space-between);\n}\n.justify-around {\n  @include justify-content(space-around);\n}\n.justify-evenly {\n  @include justify-content(space-evenly);\n}\n\n.wrap {\n  @include flex-wrap(wrap);\n}\n.nowrap {\n  @include flex-wrap(nowrap);\n}\n.wrap-reverse {\n  @include flex-wrap(wrap-reverse);\n}\n\n.grow-0 {\n  @include flex-grow(0);\n}\n.grow-1 {\n  @include flex-grow(1);\n}\n.shrink-0 {\n  @include flex-shrink(0);\n}\n.shrink-1 {\n  @include flex-shrink(1);\n}\n\n.basis-auto {\n  @include flex-basis(auto);\n}\n.basis-0 {\n  @include flex-basis(0);\n}\n\n.flex-auto {\n  flex: 1 1 auto;\n}\n.flex-none {\n  flex: none;\n}\n\n.order-first {\n  order: -1;\n}\n.order-last {\n  order: 1;\n}\n.order-0 {\n  order: 0;\n}\n.order-1 {\n  order: 1;\n}\n.order-2 {\n  order: 2;\n}\n.order-3 {\n  order: 3;\n}\n.order-4 {\n  order: 4;\n}\n.order-5 {\n  order: 5;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n// Grid Utility Classes\n.grid {\n  @include grid(1, 1);\n}\n.grid-cols-1 {\n  @include grid(1);\n}\n.grid-cols-2 {\n  @include grid(2);\n}\n.grid-cols-3 {\n  @include grid(3);\n}\n.grid-cols-4 {\n  @include grid(4);\n}\n.grid-cols-5 {\n  @include grid(5);\n}\n.grid-cols-6 {\n  @include grid(6);\n}\n.grid-cols-7 {\n  @include grid(7);\n}\n.grid-cols-8 {\n  @include grid(8);\n}\n\n.grid-cols-auto {\n  @include grid(auto-fill, 1, minmax(100px, 1fr));\n}\n\n.grid-rows-1 {\n  @include grid(1, 1);\n}\n.grid-rows-2 {\n  @include grid(1, 2);\n}\n.grid-rows-3 {\n  @include grid(1, 3);\n}\n\n.grid-rows-auto {\n  @include grid(1, auto-fill, minmax(100px, 1fr));\n}\n\n.grid-auto-flow-row {\n  grid-auto-flow: row;\n}\n.grid-auto-flow-column {\n  grid-auto-flow: column;\n}\n.grid-auto-flow-dense {\n  grid-auto-flow: dense;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
